import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../common/auth/pages/LoginPage";
import NavHeader from "../common/Layout/NavHeader";
import RegisterPage from "../common/auth/pages/RegisterPage";
import ForgotPasswordPage from "../common/auth/pages/ForgotPasswordPage";
import ResetPasswordPage from "../common/auth/pages/ResetPasswordPage";
import ProtectedRoute from "../routes/ProtectedRoute";
import ProfilePage from "../common/auth/pages/ProfilePage";
import ChangePasswordPage from "../common/auth/pages/ChangePasswordPage";
import HomePage from "../common/Dashboard/HomePage";
import CreateGroupPage from "../module/Group Module/Admin/CreateGroupPage";
import EditGroupPage from "../module/Group Module/Admin/EditGroupPage";
import AdminLayout from "../module/Group Module/Admin/Layout/AdminLayout";
import AdminDashboard from "../module/Group Module/Admin/Dashboard/AdminDashboard";
import AdminGroupListPage from "../module/Group Module/Admin/AdminGroupListPage";
import AdminGroupRequestListPage from "../module/Group Module/Admin/AdminGroupRequestListPage";
import GroupDetailsPage from "../module/Group Module/Pages/GroupDetailsPage";
import CoordinatorDashboardPage from "../module/Group Module/Coordinator/CoordinatorDashboardPage";
import RoleProtectedRoute from "../routes/RoleProtectedRoute";
import ImportGroupPage from "../module/Group Module/Admin/ImportGroupPage";
import UserManage from "../module/Group Module/Admin/UserManage";
import CoordinatorHomePage from "../module/Group Module/Coordinator/Pages/CoordinatorHomePage";
import About from "../common/Dashboard/About";
import AppSettingsPage from "../module/Group Module/Pages/AppSettingsPage";
import CarDetailsPage from "../module/Car/Pages/CarDetailsPage";
import Analytics from "../common/analytics/Pages/Analytics";
import VerifyAccountPage from "../common/auth/pages/VerifyAccountPage";
import ProfileLayout from "../common/auth/Layout/ProfileLayout";
import MyGroup from "../common/auth/pages/MyGroup";
import ContactPage from "../common/Dashboard/ContactPage";
import ContactInformation from "../module/Group Module/Admin/ContactInformation"; 
import PrivacyPolicy from "../common/Dashboard/PrivacyPolicy"; 
import TermsCondition from "../common/Dashboard/Terms_Condition";
import RefundCanc from "../common/Dashboard/Refund_Canc";
import RealEngineering from "../common/Dashboard/RealEngineering";


const AppRoutes = () => {
    return (
        <>
            <NavHeader />
            <Routes>

                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/rent-car-hire-6-7-seater-ertiga-bangalore" element={<CarDetailsPage />} />
                <Route path="/verify-account" element={<VerifyAccountPage />} />
                <Route path="/terms-and-conditions" element={<TermsCondition />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/refund-policy" element={<RefundCanc />} />
                <Route path="/Experience-Real-Engineering-for-a-Day" element={<RealEngineering />} />





                <Route
                    path="/user"
                    element={
                        <ProtectedRoute>
                            <ProfileLayout />
                        </ProtectedRoute>
                    }
                >
                    {/* Default page */}
                    <Route index element={<Navigate to="profile" replace />} />

                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="change-password" element={<ChangePasswordPage />} />
                    <Route path="mygroup" element={<MyGroup />} />
                </Route>

                <Route
                    path="/analytics"
                    element={
                        <RoleProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <Analytics />
                        </RoleProtectedRoute>
                    }
                />

                <Route
                    element={
                        <RoleProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <AdminLayout />
                        </RoleProtectedRoute>
                    }
                >

                    <Route

                        path="/admin"

                        element={<AdminDashboard />}

                    />
                    <Route

                        path="/admin/users"

                        element={<UserManage />}

                    />

                    <Route

                        path="/admin/groups"

                        element={<AdminGroupListPage />}

                    />
                    <Route
                        path="/admin/groups/import"
                        element={
                            <ProtectedRoute>
                                <ImportGroupPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route

                        path="/admin/groups/create"

                        element={<CreateGroupPage />}

                    />

                    <Route

                        path="/admin/groups/edit/:groupId"

                        element={<EditGroupPage />}

                    />

                    <Route

                        path="/admin/group-requests"

                        element={<AdminGroupRequestListPage />}

                    />

                    <Route

                        path="/admin/Contact-Information"

                        element={<ContactInformation />}

                    />

                    <Route

                        path="/admin/group-settings"

                        element={<AppSettingsPage />}

                    />

                </Route>


                <Route
                    path="/groups/:slug"
                    element={<GroupDetailsPage />}
                />
                <Route
                    path="/groups/:groupId/coordinator"
                    element={
                        <RoleProtectedRoute allowedRoles={["Coordinator"]}>
                            <CoordinatorDashboardPage />
                        </RoleProtectedRoute>
                    }
                />


                <Route path="/coordinator" element={
                    <RoleProtectedRoute allowedRoles={["Coordinator"]}>
                        <CoordinatorHomePage />
                    </RoleProtectedRoute>
                } />





            </Routes>
        </>
    );
};

export default AppRoutes;